<template>
  <div id="_rightPan">
    <div class="top">
      <span>{{ hello }}</span>
      <p>{{ info }}</p>
    </div>
<!--    <div class="main">-->
<!--      <div class="item" v-for="(item, index) in groupColor" :key="index" :style="item.bgc">-->
<!--        <img :src="item.imgUrl" alt="" />-->
<!--        <div class="text">-->
<!--          <span>{{ item.title }}</span>-->
<!--          <p>{{ item.text }}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="chart">-->
<!--      <RightPancake2 :chart="main1"></RightPancake2>-->
<!--      <RightPancake3 :chart="main2"></RightPancake3>-->
<!--    </div>-->
<!--    <div class="main">-->
<!--      <div class="item" v-for="(item, index) in groupColor1" :key="index" :style="item.bgc">-->
<!--        <img :src="item.imgUrl" alt="" />-->
<!--        <div class="text">-->
<!--          <span>{{ item.title }}</span>-->
<!--          <p>{{ item.text }}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="bottom">-->
<!--      <div class="table">-->
<!--        <div class="table_header">-->
<!--          <p>待审核认证</p>-->
<!--          <p @click="wait" style="cursor: pointer;">更多></p>-->
<!--        </div>-->
<!--        <el-table-->
<!--          :data="tableData"-->
<!--          stripe-->
<!--          border-->
<!--          style="width: 100%"-->
<!--          :header-cell-style="{ textAlign: 'center', background: ' #EBEBEB' }"-->
<!--          :cell-style="{ textAlign: 'center' }"-->
<!--        >-->
<!--          <el-table-column prop="nickName" label="账号" center> </el-table-column>-->
<!--          <el-table-column prop="mobile" label="手机号码" center> </el-table-column>-->
<!--          <el-table-column prop="type" label="认证类型" center> </el-table-column>-->
<!--          <el-table-column prop="createAt" label="申请时间" center width="160"> </el-table-column>-->
<!--        </el-table>-->
<!--      </div>-->
<!--      <div class="table">-->
<!--        <div class="table_header">-->
<!--          <p>待审核资质</p>-->
<!--          <p @click="wait1" style="cursor: pointer;">更多></p>-->
<!--        </div>-->
<!--        <el-table-->
<!--          :data="tableData1"-->
<!--          stripe-->
<!--          border-->
<!--          style="width: 100%"-->
<!--          :header-cell-style="{ textAlign: 'center', background: ' #EBEBEB' }"-->
<!--          :cell-style="{ textAlign: 'center' }"-->
<!--        >-->
<!--          <el-table-column prop="name" label="标题"> </el-table-column>-->
<!--          <el-table-column prop="organName" label="发布机构"> </el-table-column>-->
<!--          <el-table-column prop="createAt" label="申请时间"> </el-table-column>-->
<!--        </el-table>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  import RightPancake2 from './pancake/_rightPancake2.vue';
  import RightPancake3 from './pancake/_rightPancake3.vue';

  export default {
    data() {
      return {
        hello: '',
        info: '',
        name: JSON.parse(storageKit.get(jsCtx.localConstant.userInfo)).name,
        teamName: JSON.parse(storageKit.get(jsCtx.localConstant.userInfo)).teamName,
        groupColor: [
          {
            imgUrl: require('@/main/assets/DSJimg2/login.png'),
            bgc: 'background: linear-gradient(90deg, #379EF4, #388DEF);',
            title: '本月注册',
            text:'',
          },
          {
            imgUrl: require('@/main/assets/DSJimg2/member.png'),
            bgc: 'background: linear-gradient(90deg, #F4699A, #F26569);',
            title: '本月个人认证',
            text: ''
          },
          {
            imgUrl: require('@/main/assets/DSJimg2/company.png'),
            bgc: 'background: linear-gradient(90deg, #865AFB, #6B5BE1);',
            title: '本月企业认证',
            text:''
          },
          {
            imgUrl: require('@/main/assets/DSJimg2/jigou.png'),
            bgc: 'background: linear-gradient(90deg, #EF9224, #F86D3D);',
            title: '本月机构认证',
            text: ''
          }
        ],
        groupColor1: [
          {
            imgUrl: require('@/main/assets/DSJimg2/news.png'),
            bgc: 'background: linear-gradient(90deg, #379EF4, #388DEF);',
            title: '本月发布资讯',
            text: ''
          },
          {
            imgUrl: require('@/main/assets/DSJimg2/setNeed.png'),
            bgc: 'background: linear-gradient(90deg, #F4699A, #F26569);',
            title: '本月发布需求',
            text:''
          },
          {
            imgUrl: require('@/main/assets/DSJimg2/need.png'),
            bgc: 'background: linear-gradient(90deg, #865AFB, #6B5BE1);',
            title: '本月采购需求',
            text: ''
          },
          {
            imgUrl: require('@/main/assets/DSJimg2/chongzhi.png'),
            bgc: 'background: linear-gradient(90deg, #EF9224, #F86D3D);',
            title: '本月充值',
            text: ''
          }
        ],
        main1: {
          title: '个人、企业、机构数量面积图',
          idName: 'main1',
        },
        main2: {
          title: '采购和需求面积图',
          idName: 'main2',
        },
        tableData: [],
        tableData1: [],
      };
    },
    components: {
      RightPancake2,
      RightPancake3
    },
    mounted() {
      this.init()
    },
    methods:{
      init() {
        let date = new Date();
        if (date.getHours() >= 0 && date.getHours() < 11) {
          this.tips = '上午好';
        } else if (date.getHours() >= 11 && date.getHours() < 15) {
          this.tips = '中午好';
        } else if (date.getHours() >= 15 && date.getHours() < 18) {
          this.tips = '下午好';
        } else {
          this.tips = '晚上好';
        }
        this.hello = this.name + `，` + this.tips +`，祝大虾软件各位同仁开心快乐每一天！`;
        this.info = `大虾软件 - 项目管理系统 - ` + this.name;
      },
    }
  };
</script>

<style lang="less" scoped>
  ._rightPan {
    width: 100%;
  }
  .top {
    box-sizing: border-box;
    width: calc(100% - 40px);
    height: 200px;
    background: #56a4fc;
    border-radius: 10px;
    margin: 20px 20px;
    padding-top: 48px;
    span {
      margin-left: 58px;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    p {
      margin: 32px 0 0 58px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .main {
    display: flex;
    justify-content: space-evenly;
    margin: 20px 0;
    .item {
      box-sizing: border-box;
      width: calc((100% - 100px) / 4);
      height: 140px;
      border-radius: 10px;
      display: flex;
      padding: 30px;
      img {
        width: 70px;
        height: 80px;
        margin-right: 25px;
      }
      .text {
        padding: 10px 0;
        width: 100%;
        span {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
        p {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }
  .chart {
    display: flex;
    justify-content: space-evenly;
  }
  .bottom {
    display: flex;
    justify-content: space-evenly;

    .table {
      box-sizing: border-box;
      background-color: #fff;
      width: calc((100% - 60px) / 2);
      padding: 20px;
      .table_header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        :nth-child(1) {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
        :nth-child(2) {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #999999;
        }
      }
    }
  }
</style>
